// Базовый URL нормализуется (без завершающего слэша) — как в adminApi.ts,
// чтобы значение REACT_APP_API_URL работало и со слэшем на конце, и без него.
const API_URL = (process.env.REACT_APP_API_URL ?? 'https://api.amazingrp.ru').replace(/\/+$/, '');

export const checkResponse = (res: Response) => (res.ok ? res.json() : res.json().then((error: unknown) => Promise.reject(error)));

export const getPaymentTypes = () => {
  return fetch(`${API_URL}/api/v1/payment/systems`, { method: 'GET' })
    .then(checkResponse);
};

export const getUserId = (id: string) => {
  return fetch(`${API_URL}/api/v1/player/${id}`, { method: 'GET' })
    .then(checkResponse);
};

export const getInvoice = (type: string, amount: number, steamid: string, email: string) => {
  return fetch(
    `${API_URL}/api/v1/payment/${type}/invoice`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ amount, steam_id: steamid, email }),
    }
  ).then(checkResponse);
};

export const getServerState = () => {
  return fetch(`${API_URL}/api/v1/server/info`, { method: 'GET' })
    .then(checkResponse);
};
